import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';


import { SummaryPaymentRoutingModule } from './summary-payment-routing.module';
import { SummaryPageComponent } from './pages/summary-page/summary-page.component';
import { SharedModule } from '@shared/shared.module';


@NgModule({
  declarations: [
    SummaryPageComponent
  ],
  imports: [
    CommonModule,
    SummaryPaymentRoutingModule,
    SharedModule,
  ]
})
export class SummaryPaymentModule { }
